enum JobStatusEnum {
  INACTIVE = 'inactive',
  EXPIRED = 'expired',
  PUBLISHED = 'published',
  PENDING_PUBLICATION = 'pending_publication',
}

export default JobStatusEnum;
